import { render } from "./UserDashboard.vue?vue&type=template&id=6004f2aa"
import script from "./UserDashboard.vue?vue&type=script&lang=js"
export * from "./UserDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__